import { useContext } from 'react';
import { LoginFlowContext, type LoginFlowContextValue } from './flowContext';

export function useLoginFlow(): LoginFlowContextValue {
  const ctx = useContext(LoginFlowContext);
  if (!ctx) throw new Error('useLoginFlow must be used inside LoginFlowProvider');
  return ctx;
}
